//// Application Packages
import React, { useMemo } from 'react'
import { useNavigate } from 'react-router-dom'

//// Application Slices

//// Application Components

//// Carbon Components
import {
    StructuredListWrapper,
    StructuredListHead,
    StructuredListRow,
    StructuredListCell,
    StructuredListBody,
    Tile,
    Button,
} from '@carbon/react'

//// Carbon Icons
import { Edit } from '@carbon/icons-react'

//// Static Constants

//////// Component
const SubmissionStructuredListComponent = ({
    form: { written_name, route, summary },
}) => {
    //////// Hooks
    const navigate = useNavigate()

    //////// State

    //////// Slices

    //// Slice Data

    //////// Search Params

    //////// Methods

    //////// Functional Methods
    const handleNavigation = async (e, route) => {
        e.preventDefault()
        navigate(route ? route : '/')
    }

    //////// Memoization
    const fields = useMemo(() => Object?.keys(summary), [summary])
    const values = useMemo(() => Object?.values(summary), [summary])

    //////// Effects/Side Effects

    //////////////// Render & Return
    if (fields?.length > 0 && values?.length > 0 && written_name && route) {
        return (
            <>
                <div className="form-structured-list-group-item">
                    <Tile>
                        <h4 className="form-structured-list-group-item-title">
                            {written_name}:
                        </h4>

                        {fields.map((el, i) => (
                            <StructuredListWrapper
                                ariaLabel="Structured list"
                                key={i}
                            >
                                <StructuredListHead>
                                    <StructuredListRow head tabIndex={0}>
                                        <StructuredListCell head>
                                            {el}
                                        </StructuredListCell>
                                    </StructuredListRow>
                                </StructuredListHead>
                                <StructuredListBody>
                                    <StructuredListRow tabIndex={0}>
                                        <StructuredListCell>
                                            {values[i]}
                                        </StructuredListCell>
                                    </StructuredListRow>
                                </StructuredListBody>
                            </StructuredListWrapper>
                        ))}

                        <div className="form-submission-structured-list-edit-button-group">
                            <div className="form-submission-structured-list-edit-button-group-item">
                                <Button
                                    className="fldoh-btn"
                                    type="button"
                                    kind="tertiary"
                                    size="md"
                                    onClick={(e) =>
                                        handleNavigation(e, `${route}`)
                                    }
                                >
                                    Edit
                                    <Edit />
                                </Button>
                            </div>
                        </div>
                    </Tile>
                </div>
            </>
        )
    }
}

export default SubmissionStructuredListComponent
